import { Component, OnInit } from '@angular/core';
import * as $ from 'jquery';
import {DataserviceService} from '../../dataservice.service';
// import { ResizedEvent } from 'angular-resize-event/resized-event';





@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
height:Number;
showDashboardData = {
  total_banks:'',
  total_updates:''
};





  constructor(private dataservice:DataserviceService) { }


  

     setHeight(){
        var nnn1= $('.content-header.content-header-media').innerHeight();
    var nnn2 = $('.clearfix').innerHeight();
    console.log(nnn2);
    console.log(innerHeight);
    
    
    this.height =innerHeight -  nnn1 - nnn2 +18 ;
    }

    // onResized(event: ResizedEvent): void {
    //   console.log("naina");
    //   this.setHeight();
      
    //  }



  ngOnInit() {

this.setHeight();






 




    this.dataservice.dashboardData().subscribe(
      data=>{
        console.log(data);
        this.showDashboardData=data;
        
      }
    )
  }




  

}
